import React from "react"
import { useSelector } from "react-redux"
import { Col } from "react-bootstrap"

import { CcRequirementReviewMethod } from "server/models"
import {
    StoreType,
    ReviewMethodsType,
} from "client/store"
import {
    CheckboxWrapper,
    CheckButton,
} from "client/components"

interface ReviewMethodsProps {
    reviewMethods: ReviewMethodsType
    setReviewMethods: (reviewMethods: ReviewMethodsType) => void
}

const ReviewMethods = ({
    reviewMethods,
    setReviewMethods,
}: ReviewMethodsProps) => {
    const methodList = useSelector((state: StoreType) => state.ccRequirementReviewMethod.methodList)
    const methodIds = useSelector((state: StoreType) => state.ccRequirementReviewMethod.methodIds)

    const columnNumber = 3

    const methodColumnLength = Math.ceil(methodIds.length / columnNumber)
    const methodColumns: { [columnIndex: number]: CcRequirementReviewMethod[] } = {}
    for (let i = 0; i < columnNumber; i++) {
        const column = []
        const start = i * methodColumnLength
        const end = start + methodColumnLength
        for (let k = start; k < end; k++) {
            const methodId = methodIds[k]
            column.push(methodList[methodId])
        }
        methodColumns[i] = column
    }

    return (
        <CheckboxWrapper>
            {
                Object.keys(methodColumns).map((index) => (
                    <Col key={index} xs={12} md={12 / columnNumber}>
                        {
                            methodColumns[Number(index)].map((method) => method && (
                                <CheckButton
                                    key={method.id}
                                    title={method.name}
                                    checked={reviewMethods[method.id] === true}
                                    onChange={() => {
                                        const newReviewMethods = { ...reviewMethods }
                                        newReviewMethods[method.id] = !newReviewMethods[method.id]
                                        setReviewMethods(newReviewMethods)
                                    }}
                                />
                            ))
                        }
                    </Col>
                ))
            }
        </CheckboxWrapper>
    )
}
export default ReviewMethods
